import axios from "../../api/axios";

export const useRefreshToken = () => {
  const refreshToken = async (props) => {
    const access_token = props?.access_token || localStorage.getItem("access_token");
    const refresh_token = props?.refresh_token || localStorage.getItem("refresh_token");

    if (!refresh_token || refresh_token === "null" || refresh_token === "undefined") {
      throw new Error("Missing refresh token");
    }

    const headers = {
      Accept: "application/json",
    };
    if (access_token && access_token !== "null" && access_token !== "undefined") {
      headers.Authorization = `Bearer ${access_token}`;
    }

    const { data } = await axios.post(
      "refresh",
      { refresh_token },
      { headers }
    );

    return data;
  };

  return refreshToken;
};
